<template>
  <v-container fluid class="account-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/account/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="accounts-table"
              show-select
              single-select
              item-key="_id"
              sort-by="accountnum"
              :footer-props="footer"
              :headers="header_item"
              :items="accounts"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteAccount"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Account?
                    </v-card-title>

                    <v-card-text>
                      {{ delete_account.accountname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteAccount = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteAccount(delete_account)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.accountname="{ item }">
                <p class="two-line"><b>{{ item.accountclass}} : {{item.accountsubclass }}</b></p>
                <p class="two-line">{{ item.accountnum }} : {{ item.accountname }}</p>
              </template>
              <template v-slot:item.parent_accountid="{ item }">
                <div v-if="item.parent_accountid">{{ accounts.length>0 ? accounts.find(account=>account._id == item.parent_accountid)['accountname'] : '' }}</div>
              </template>
              <template v-slot:item.accountstatus="{ item }">
                <v-chip
                  v-if="item.accountstatus!=undefined"
                  :color="getStatusColor(item.accountstatus)" small
                >
                  {{ item.accountstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteAccountDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getStatusColor } from '../../../util/tools';

export default {
  name: 'accountList',
  data() {
    return {
      isDeleteAccount: false,
      delete_account: {},
      header_item: [
        { text: 'Num', value: 'accountnum', width: '8%' },
        { text: 'Type', value: 'accounttype', width: '8%' },
        { text: 'Name', value: 'accountname' },
        { text: 'Sum Account', value: 'parent_accountid', width: '10%' },
        { text: 'Status', value: 'accountstatus', width: '10%' },
        { text: 'Create', value: 'createdAt', width: '10%' },
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      data_selected: [],
      getStatusColor: getStatusColor,
    }
  },

  computed: {
    ...mapState('Account', ['accounts', 'isReceiving', 'isDeleting', 'idToDelete', 'accountsMessage', 'isUpdating']),
  },

  methods: {
    ...mapActions('Account', ["getAccountsRequest","deleteAccountRequest"]),
    editItem(item) {
      this.$router.push({ name: 'AccountEdit', params: item })
    },
    deleteAccount(item) {
      this.deleteAccountRequest({_id: item._id});
      this.isDeleteAccount = false;
    },
    deleteAccountDialog(item) {
      this.isDeleteAccount = true;
      this.delete_account = { _id: item._id, accountname: item.accountname }
    },
  },
  async created () {
      await this.getAccountsRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
